export enum LoanPaymentMethodAction {
  EDIT_BORROWER = 'EDIT_BORROWER',
  EDIT_CO_BORROWER = 'EDIT_CO_BORROWER',
  ADD_CO_BORROWER = 'ADD_CO_BORROWER',
}
